import { useClient } from "#/hook/useClient";
import { formatDate } from "#/utils/dateTimeUtils";
import { Text } from "@mantine/core";
import { IconCalendar } from "@tabler/icons-react";

const TodayView = () => {
	const { client } = useClient();
	return (
		<div className="bg-white rounded-full px-4 h-full items-center flex gap-2">
			<div className="w-6 h-6 relative">
				<IconCalendar />
			</div>
			<Text size="md">{formatDate(new Date(), client)}</Text>
		</div>
	);
};

export default TodayView;
